import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../core/core.module';
import { SettingsComponent } from './settings.component';
import { AuthGuard, LocationService } from 'src/app/core/providers';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClientSelectionComponent } from './client-selection/client-selection.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerSelectionComponent } from './customer-selection/customer-selection.component';
import { ProfileService } from 'src/app/core/providers/services/profile.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { GeolocationService } from '@ng-web-apis/geolocation';
import { LocationSettingsComponent } from './location-settings/location-settings.component';
import { ToggleButtonComponent } from 'src/app/core/components/toggle-button/toggle-button.component';
import { SignOutModalComponent } from 'src/app/core/components/sign-out-modal/sign-out-modal.component';
import { ProductSortComponent } from './product-sort/product-sort.component';
import { ItemArrowComponent } from '../../core/components/item-arrow/item-arrow.component';
import { AppRoutes } from 'src/app/core/models';
import { EstimateTypeComponent } from './estimate-type/estimate-type.component';
import { ButtonRadioComponent } from './components/button-radio.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: AppRoutes.settings.slice(1), //'settings'
        component: SettingsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: AppRoutes.clientSelection.slice(1), //'settings/client-selection',
        component: ClientSelectionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: AppRoutes.customerSelection.slice(1), // 'settings/customer-selection',
        component: CustomerSelectionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: AppRoutes.locationSettings.slice(1), //'settings/location-settings',
        component: LocationSettingsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: AppRoutes.productSortSettings.slice(1), // 'settings/product-sort',
        component: ProductSortComponent,
        canActivate: [AuthGuard],
      },
      {
        path: AppRoutes.estimateSettings.slice(1), // 'settings/estimate-type',
        component: EstimateTypeComponent,
        canActivate: [AuthGuard],
      },
    ]),
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CoreModule,
    MatTooltipModule,
    InfiniteScrollModule,
    ItemArrowComponent,
    ButtonRadioComponent,
  ],
  providers: [ProfileService, GeolocationService, LocationService],
  declarations: [
    SettingsComponent,
    SignOutModalComponent,
    ClientSelectionComponent,
    CustomerSelectionComponent,
    LocationSettingsComponent,
    ToggleButtonComponent,
    ProductSortComponent,
    EstimateTypeComponent,
  ],
})
export class SettingsModule {}
